/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_Point_1Inputs */

const en_atelier_point_1 = /** @type {(inputs: Atelier_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linesheets and products from the brand, attributes included`)
};

/**
* | output |
* | --- |
* | "Linesheets and products from the brand, attributes included" |
*
* @param {Atelier_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_point_1 = /** @type {((inputs?: Atelier_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_point_1(inputs)
});